import {useState,useEffect,useContext} from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Card,CardBody,CardHeader } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { ProyectosAprobado } from '../interfaces/ProyectoAprobado';
import axios from 'axios';
import {HiOutlineDocumentSearch} from 'react-icons/hi';
import{Button} from '@mui/material';
import { CasUserContext, useCasUserContext } from '../services/casUserContext'; 

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export function ProyectosAprob() {
 const {id} = useParams();  
 let history = useNavigate(); 
 const localBack : string = process.env.REACT_APP_BACK || '';
 const[data,setData] = useState<Array<ProyectosAprobado>>([]);
 //const casUserContext = useContext(CasUserContext);
 const casUserContext = useCasUserContext();
 const token = casUserContext.token;

 const goToNavigation = (site:string) =>{
  history(site)
}

 useEffect(() => {  
  const fetchData = async () =>{
    try{
      const response = await axios.get(localBack+'/api/Proyecto/GetProyectosAprob/'+id,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setData(response.data.objDatos);
      //console.log(data)
    }catch(error){
      console.error('Error:',error);
    }
  };
  fetchData();
  },[]);
 
  return (
      <Card>
      <CardHeader>Proyectos Aprobados</CardHeader>
      <CardBody>
      <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Código</StyledTableCell>
            <StyledTableCell align="left">Titulo</StyledTableCell>
            <StyledTableCell align="left">Estado</StyledTableCell>
            <StyledTableCell align="left">Opciones</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <StyledTableRow key={row.idProyecto}>
              <StyledTableCell component="th" scope="row">
                {row.codigo}
              </StyledTableCell>
              <StyledTableCell align="left">{row.titulo}</StyledTableCell>
              <StyledTableCell align="left">{row.estado}</StyledTableCell>
              <StyledTableCell align="left">
                <Button variant="contained" endIcon={<HiOutlineDocumentSearch />} onClick={() => {goToNavigation('/proyecto/'+id+'/'+row.idProyecto)}}>Detalle</Button>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
      </CardBody>
   </Card>
  )
}
